import { action, computed, observable } from "mobx";
import { IndexRange } from "react-virtualized";
import { VirtualSearchManager } from "./VirtualSearchManager";
import { uniqBy } from "lodash";

type RowType<T, Type extends "group"> = {
  _id: string;
  header: T;
  type: Type;
};

/**
 * @deprecated outdated functionality. Use InfiniteScrollSearchManager with <InfiniteScroll />
 */
export class GroupedVirtualSearchManager<
  T extends RowType<U, any>,
  U = T["header"]
> extends VirtualSearchManager<T> {
  @observable private _header: U = null;

  @computed get header() {
    return this._header;
  }

  @action.bound onRowsRendered(opts: { startIndex: number }) {
    this.setGroup(opts.startIndex);
  }

  @action.bound setGroup(rowIndex: number) {
    if (this.items.length === 0 || !this.items[rowIndex]) {
      this._header = null;
      return;
    }

    this._header = { ...this.items[rowIndex].header };
  }

  @action.bound clear(preserveScrollPosition = false) {
    super.clear(preserveScrollPosition);
    this._header = null;
  }

  merge = (rows: T[]) => {
    this._items = uniqBy([...rows, ...this._items], "_id"); // it fixes problem when we use polling and scroll to the top
    if (this.refresh) {
      this.refresh();
    }
  };

  loadMoreRows = (params: IndexRange) => {
    const headersNum = this._items.filter((x) => x.type === "group").length;
    const skip = params.startIndex - headersNum;
    const limit = params.stopIndex - params.startIndex;

    return this.fetch(skip, limit);
  };
}
